import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-message-box',
    templateUrl: './message-box.component.html',
    styleUrls: ['./message-box.component.scss'],
    standalone: false
})
export class MessageBoxComponent {
    @Input({required: true})
    public type!: 'info' | 'error' | 'warning' | 'success';
    @Input()
    public header: string | undefined;
    @Input()
    public content: string | undefined;
    @Input()
    public showIcon: boolean = true;
}
